"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteMatrixLedDriver = void 0;
const PixelApi_1 = require("./PixelApi");
const TextApi_1 = require("./TextApi");
const ImageApi_1 = require("./ImageApi");
class RemoteMatrixLedDriver {
    constructor(configuration) {
        this._pixelApi = new PixelApi_1.PixelApi(configuration);
        this._textApi = new TextApi_1.TextApi(configuration);
        this._imageApi = new ImageApi_1.ImageApi(configuration);
    }
    get pixel() { return this._pixelApi; }
    get text() { return this._textApi; }
    get image() { return this._imageApi; }
}
exports.RemoteMatrixLedDriver = RemoteMatrixLedDriver;
//# sourceMappingURL=RemoteMatrixLedDriver.js.map